import { LabelProps, LabelType, Variant } from './types';
import { Label as StyledLabel } from './Label.styled';

export const Label = ({ type = LabelType.Primary, children, ...props }: LabelProps) => {
  const variant = (
    type === LabelType.Work ||
    type === LabelType.Mobile ||
    type === LabelType.Home ||
    type === LabelType.Other
      ? 'caption2'
      : 'caption'
  ) as Variant;
  return (
    <StyledLabel type={type} variant={variant} {...props}>
      {children}
    </StyledLabel>
  );
};

export default Label;
